import http from './http';

export type ApplyJobResponse = {
  success: boolean;
  status?: boolean;
  needs_profile?: boolean;
  already_applied?: boolean;
  application_id?: number | null;
  outsource_id?: number | null;
  job_id?: number;
  next_step?: 'complete_profile' | 'thank_you' | 'already_applied';
  message?: string;
};

export const applicationService = {
  getCandidateProfile: () => http.get('outsource/me'),
  updateCandidateProfile: (payload: Record<string, unknown>) => http.put('outsource/me', payload),
  apply: (jobId: number) => http.post<ApplyJobResponse>(`jobs/${jobId}/apply`),
};
